import { Stack } from "@mui/material";
import { SectionBox } from "@foodpilot/foods";
import { useProductMetadataContext } from "src/context/Product/Metadata/useProductMetadata";
import { PACKAGING, useFoodpilotContext, VIEW } from "src/context/FoodpilotContext";
import { Navigate } from "react-router";
import { URLHandler } from "src/services/URLHandler";
import { useCompanyMetadata } from "src/context/Company/Metadata/useCompanyMetadata";
import { EntitiesHeader } from "../EntitiesHeader";
import { useTranslation } from "react-i18next";
import { EntitiesData } from "../EntitiesData";
import { PackagingsDataRow } from "./PackagingsDataRow";
import { ProductPackaging } from "src/api/client-api/products/useGetOneProduct";
import { ProductScoreChartColumn } from "../../ProductScoreChartColumn";

export const Packagings = () => {
    const { t } = useTranslation();
    const { canUser } = useFoodpilotContext();
    const { company } = useCompanyMetadata();
    const { product } = useProductMetadataContext();

    const isIntermediateProduct = product.isIntermediate === true;
    const urlHandlerRoutes = isIntermediateProduct ? URLHandler.intermediateProduct : URLHandler.product;

    const summaryUrl = urlHandlerRoutes.ssqSummary(company.id, product.id);
    if (!canUser(VIEW, PACKAGING)) return <Navigate to={summaryUrl} replace />;

    return (
        <SectionBox
            header={
                <EntitiesHeader
                    icon="packaging"
                    title={t("packagings")}
                    count={product?.productPackagings?.length ?? 0}
                />
            }
            borderRadius={4}
            sx={{ backgroundColor: "white" }}
        >
            <Stack direction={"row"} gap={3.5} sx={{ backgroundColor: "white" }}>
                <Stack flex={5} gap={3}>
                    <EntitiesData
                        key="packaging-data"
                        productEntities={product.productPackagings}
                        entityDataRowHandler={(productPackaging: ProductPackaging) => (
                            <PackagingsDataRow productPackaging={productPackaging} />
                        )}
                        noEntitiesMessage={t(
                            "pas_d_emballage_associe_a_ce_produit",
                            "No packaging associated with this product",
                        )}
                    />
                </Stack>

                <ProductScoreChartColumn dimension="packagings" />
            </Stack>
        </SectionBox>
    );
};
